import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/';
import { SessionService } from '../angular-services-v8/session.service';
import { Application } from '../models/application';
import { User } from '../models/user';
import { SharedFunctions } from '../helpers/functions';
import { ILegalEntity } from '../angular-types-v2/interfaces';

class LegalEntityChange {
    changed: boolean;
    value: number;
}

@Injectable()
export class StorageService {

    public legalEntityChanged$ = new BehaviorSubject<LegalEntityChange>(null);

    constructor(private sessionService: SessionService, private sharedFunctions: SharedFunctions) { }

    public getFromLocalStorage(key: string): string {
        return localStorage.getItem(key);
    }

    public getFromSessionStorage(key: string): string {
        return sessionStorage.getItem(key);
    }

    public get selectedLegalEntity(): ILegalEntity | null {
        return this.sessionService.currentLegalEntityValue;
    }

    public get userId(): number {
        const profileJson = this.sessionService.profile ? this.sessionService.profile : undefined;
        return profileJson ? profileJson.userId : undefined;
    }

    public get userApplications(): Application[] {
        return this.sessionService.applicationsList || [];
    }

    public get defaultCustomer() {
        return this.sessionService.customerDetail;
    }

    public get userCountry(): string {
        const country = this.sessionService.userCountry || undefined;
        return country;
    }


    getUserListPermissions(): User[] {
        const usersStorage = this.sharedFunctions.parseFromStorage<User[]>('session', 'users_edit');
        return usersStorage ?? [];
    }

    setUserListPermissions(users: User[]) {
        sessionStorage.setItem('users_edit', JSON.stringify(users));
    }

    clearUserListPermissions() {
        sessionStorage.removeItem('users_edit');
    }
}
